import { render } from "./icon-clouds-sun.vue?vue&type=template&id=7c5b7818"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__